<template>
    <div
        class="price-card-market"
        :class="{ 'price-card-market-wide': useTwoColumns }"
    >
        <div class="price-card-market-header">
            <h5>
                {{ productName }}

                <span v-if="product.Težina">
                    {{ product.Težina }}
                </span>
            </h5>

            <small v-if="product['Jedinica mere']">
                {{ product['Jedinica mere'] }}
            </small>

            <small v-else>
                {{ product.Rasa }}
            </small>
        </div>

        <div
            v-if="minPrice && maxPrice"
            class="price-summary"
        >
            <div class="summary-item">
                <div class="summary-content">
                    <span>Najniža cena</span>

                    <strong>
                        {{ formatPrice(minPrice.price) }} din/{{ unit }}
                    </strong>

                    <small :title="minPrice.city">
                        {{ minPrice.city }}
                    </small>
                </div>
            </div>

            <div class="summary-item">
                <div class="summary-content">
                    <span>Najviša cena</span>

                    <strong>
                        {{ formatPrice(maxPrice.price) }} din/{{ unit }}
                    </strong>

                    <small :title="maxPrice.city">
                        {{ maxPrice.city }}
                    </small>
                </div>
            </div>
        </div>

        <div
            class="price-card-market-body"
            :class="{ 'two-columns': useTwoColumns }"
        >
            <div class="price-city-column">
                <div
                    v-for="item in firstColumnCities"
                    :key="item.city"
                    class="price-row"
                >
                    <span
                        class="city"
                        :title="item.city"
                    >
                        <i class="bi bi-geo-alt"></i>
                        {{ item.city }}
                    </span>

                    <span class="price">
                        {{ formatPrice(item.price) }}
                        <small>din/{{ unit }}</small>
                    </span>
                </div>
            </div>

            <div
                v-if="useTwoColumns"
                class="price-city-column"
            >
                <div
                    v-for="item in secondColumnCities"
                    :key="item.city"
                    class="price-row"
                >
                    <span
                        class="city"
                        :title="item.city"
                    >
                        <i class="bi bi-geo-alt"></i>
                        {{ item.city }}
                    </span>

                    <span class="price">
                        {{ formatPrice(item.price) }}
                        <small>din/{{ unit }}</small>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    product: {
        type: Object,
        required: true
    },

    week: {
        type: Object,
        required: false,
        default: () => ({})
    }
})

const skipKeys = [
    'Proizvod',
    'Jedinica mere',
    'Rasa',
    'Težina',
    'Godina'
]

const productName = computed(() => {
    return props.product.Proizvod
        ?.split('v:')
        .shift()
        .trim() || ''
})

const unit = computed(() => {
    return props.product['Jedinica mere'] || 'kg'
})

const cities = computed(() => {
    return Object.entries(props.product)
        .filter(([key, value]) =>
            !skipKeys.includes(key) &&
            value !== null &&
            value !== ''
        )
        .map(([city, price]) => ({
            city,
            price: Number(price)
        }))
})

const useTwoColumns = computed(() => {
    return cities.value.length > 10
})

const half = computed(() => {
    return Math.ceil(cities.value.length / 2)
})

const firstColumnCities = computed(() => {
    return useTwoColumns.value
        ? cities.value.slice(0, half.value)
        : cities.value
})

const secondColumnCities = computed(() => {
    return useTwoColumns.value
        ? cities.value.slice(half.value)
        : []
})

const minPrice = computed(() => {
    if (!cities.value.length) {
        return null
    }

    return cities.value.reduce((min, item) =>
        item.price < min.price ? item : min
    )
})

const maxPrice = computed(() => {
    if (!cities.value.length) {
        return null
    }

    return cities.value.reduce((max, item) =>
        item.price > max.price ? item : max
    )
})

const formatPrice = (price) => {
    // return Number(price).toLocaleString('sr-RS', {
    //     minimumFractionDigits: 0,
    //     maximumFractionDigits: 0
    // })
    return price;
}
</script>